<ngx-spinner name="upsSpinner" bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#321815" type="custom" [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>
<div class="row main-container">
  <div class="card card-body flex-fill filter-card">
    <div class="col filter-col">
      <form class="filter-form enhanced-filter-form">
        <mat-form-field appearance="outline" class="filter1 enhanced-filter-field">
          <mat-label class="bold-label">Report Type</mat-label>
          <mat-select
            [(ngModel)]="requestReportSearch.reportType"
            name="reportType"
            (selectionChange)="onReportTypeChange($event)">
            <mat-option [value]="1">BAT Request</mat-option>
            <mat-option [value]="2">Download Digital Copies</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="filter-field" *ngIf="reportTypeFlag === 'BAT'" style="flex: 1; min-width: 200px;">
        <mat-label style="font-weight: bold;">Start Date</mat-label>
        <input
          matInput
          [(ngModel)]="requestReportSearch.startDate"
          [matDatepicker]="startDatepicker"
          placeholder="MM/DD/YYYY"
          name="startDate" />
          <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatepicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field enhanced-filter-field" *ngIf="reportTypeFlag === 'BAT'">
          <mat-label class="bold-label">End Date</mat-label>
          <input
            matInput
            [(ngModel)]="requestReportSearch.endDate"
            [matDatepicker]="endDatepicker"
            placeholder="MM/DD/YYYY"
            name="endDate" />
            <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatepicker></mat-datepicker>
          </mat-form-field> -->

          <!-- <mat-form-field *ngIf="reportTypeFlag !== 'DigitalCopies'" id="statusFilter" class="filter1" appearance="outline">
          <mat-label class="font-bold">Status</mat-label>
          <mat-select  [(ngModel)]="requestReportSearch.statusType" name="statusType">
            <mat-option [value]="0">All</mat-option>
            <mat-option [value]="1">Submitted</mat-option>
            <mat-option [value]="16">PRS Submitted</mat-option>
            <mat-option [value]="5">First Level Approved</mat-option>
            <mat-option [value]="3">First Level Need More Information</mat-option>
            <mat-option [value]="4">First Level Rejected</mat-option>
            <mat-option [value]="6">Completed</mat-option>
            <mat-option [value]="7">Received</mat-option>
            <mat-option [value]="8">Waiting for Approval</mat-option>
            <mat-option [value]="9">Sent to Corrections</mat-option>
            <mat-option [value]="10">Pending Rebill</mat-option>
            <mat-option [value]="11">GBS Rejected</mat-option>
            <mat-option [value]="13">GBS Need More Info</mat-option>
            <mat-option [value]="17">Completed - Refund info is needed</mat-option>

            <mat-option [value]="14">Cancelled</mat-option>
            <mat-option [value]="15">Saved</mat-option>
          </mat-select>
        </mat-form-field>

        <button type="button" class="btn btn-primary apply-button" (click)="onSubmit(1,10)" *ngIf="reportTypeFlag === 'BAT'">
          <i class="fas fa-search"></i>&nbsp;Apply
        </button>-->

        @if (reportTypeFlag === 'DigitalCopies') {
          <mat-form-field appearance="outline" class="filter-field enhanced-filter-field">
            <mat-label [ngClass]="{'input-error-red': adjReqIdError}" class="bold-label">Adjustment Request ID</mat-label>
            <input matInput type="text" maxlength="12" pattern="^[0-9]*$" (keypress)="allowOnlyNumbers($event)" [(ngModel)]="requestReportSearch.adjReqId" placeholder="Enter AdjReqId" name="adjReqId"
              (input)="onAdjReqIdInput()" />
            </mat-form-field>
          }

          @if (reportTypeFlag === 'DigitalCopies') {
            <button type="button" class="btn btn-success generate-button" (click)="onGenerate()">
              <i class="fas fa-search"></i>&nbsp;Generate
            </button>
          }
        </form>
      </div>
    </div>
  </div>

  <div class="col-12">
    @if (reportTypeFlag === 'BAT') {
      <div class="card card-body history-card">
        <span class="list-title enhanced-list-title">Billing Adjustment Request History</span>
        <div class="row history-row"></div>
        <div class="col-12">
          <div class="col-9">
            <mat-card appearance="outlined" class="legend-card">
              <mat-card-header>
                <mat-card-title class="card-title legend">Legend-SLA Information</mat-card-title>
          
              </mat-card-header>
              <mat-card-content class="card-content">
                <app-legend [data]="[{color: '#fff8dc', title: miApprovalLegend}, {color: '#f7c3c3', title: gbsApprovalLegend}]"></app-legend>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-3">
            <button type="button" class="btn btn-info btn-lg float-right export-button" (click)="exportXLSX()" data-toggle="button">
              <i class="fas fa-file-excel"></i>&nbsp;Export
            </button>
          </div>
        </div>
        <app-dynamictable [displayedColumns]="displayedColumns"
          [totalCount]="totalCount"
          [pageSize]="pageSize"
          [useManualPaging]=true
          (paginationChange)="onSubmit($event.pageIndex + 1, $event.pageSize, [], $event.isRefresh || false)"
          (filterChange)="onSubmit(1, 10, $event.filters, false)"
        [isFromReports]="true" [dataSource]="dataSource" (openDialog)="openAcceptOrRejectDialog($event, template)"></app-dynamictable>
      </div>
    }

    @if (reportTypeFlag === 'DigitalCopies') {
      <div class="card card-body digital-copies-animated digital-copies-card">
        <div class="digital-header">
          <span class="list-title fade-in digital-title">Billing Adjustment Request Digital Document</span>
        </div>
        @if (adjReqIdError) {
          <div class="adjreqid-warning-onscreen">
            <i class="fas fa-exclamation-triangle"></i>
            {{ adjReqIdErrorMessage }}
          </div>
        }
        @if (pdfSrc && !adjReqIdError) {
          <div class="pdf-fade-in pdf-container">
            <iframe [src]="pdfSrc" type="application/pdf" class="pdf-iframe" title="Request status report PDF"></iframe>
          </div>
        }
      </div>
    }
  </div>


